import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router';

import DashboardContainer from '../../layouts/dashboard-layout/dashboard-container';
import { SubscriptionLayout } from '../../layouts/subscription-layout';
const ManagePortfolioHome = lazy(() => import('../../pages/dashboard/manage-portfolio/home/index'));
const PreviewCSV = lazy(() => import('../../pages/dashboard/manage-portfolio/preview-csv'));
const MPSPage = lazy(() => import('../../pages/dashboard/manage-portfolio/manage-portfolio-securities'));
const MPSRebalancingPage = lazy(() => import('../../pages/dashboard/manage-portfolio/manage-portfolio-rebalancing'));

const ManagePortfolioRoutes = [
  {
    path: 'manage-portfolio',
    element: (
      <DashboardContainer variant="lg" containerSx={{ height: '100%' }}>
        <SubscriptionLayout requiredFeature="MODEL_PORTFOLIO">
          <Outlet />
        </SubscriptionLayout>
      </DashboardContainer>
    ),

    children: [
      { index: true, element: <ManagePortfolioHome /> },
      { path: 'preview-csv', element: <PreviewCSV /> },
      { path: 'mps', element: <MPSPage /> },
      { path: 'rebalancing', element: <MPSRebalancingPage /> },
      { path: '*', element: <Navigate to="/" /> },
    ],
  },
];
export default ManagePortfolioRoutes;
